import { Checkbox } from "../../../components/checkbox/checkbox.jsx";
import { DeleteIcon, FlagIcon, LightningIcon } from "../../../assets/icons";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import classNames from "classnames";

import styles from "./workerCheckList.module.css"
import { useOpenPage } from "../../../hooks/useOpenPage.js";

import { Text } from "../../../components/text/text";

const getDaysText = (n) => {
    if (n === 1) return "день";
    if ([11, 12, 13, 14].includes(n % 100)) return `${n} дней`;
    if (n % 10 === 1) return `${n} день`;
    if ([2, 3, 4].includes(n % 10)) return `${n} дня`;
    return `${n} дней`;
}

const priorities = ["Низкий", "Средний", "Высокий"];

export const CheckListItem = ({ data, setData, onDeleteTask, isDailyTasks, tabId }) => {
    const checked = data.countDone >= data.countTotal;

    const [Popup, open] = useConfirmPopup(
        "Подтвердите действие",
        "Вы уверены, что хотите удалить задание?",
        () => onDeleteTask(data.id)
    );

    const openPage = useOpenPage();

    return (
        <>
            <div className={styles.check_list_item} onClick={() => {
                if (isDailyTasks) {
                    openPage(`${data.id}?initialTab=${tabId}`)();
                } else {
                    openPage(`edit?type=reccurent&taskId=${data.id}`)();
                }
            }}>
                <div className={styles.check_list_item_extended_header}>
                    <div className={styles.check_list_item_header}>
                        {
                            isDailyTasks &&
                            <div onClick={(e) => e.stopPropagation()}>
                                <Checkbox checked={checked} onChange={() => { }} />
                            </div>
                        }

                        <div className={styles.check_list_item_info}>
                            <div className={styles.extra_header}>
                                <Text as="div" variant="body" className={styles.check_list_item_name} >{data.taskText}</Text>
                                {
                                    isDailyTasks &&
                                    <div className={classNames(styles.check_list_item_priority, {
                                        [styles.low]: data.priority === 0,
                                        [styles.medium]: data.priority === 1,
                                        [styles.high]: data.priority === 2,
                                    })}>
                                        <LightningIcon />
                                        {priorities[data.priority]}
                                    </div>
                                }
                            </div>
                            <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                {
                                    (data.repeatEveryNDays !== null) &&
                                    <Text as="div" variant="body" className={styles.check_list_item_subname} >{`Раз в ${getDaysText(data.repeatEveryNDays)}`}</Text>
                                }
                                {
                                    !isDailyTasks && data.countTotal > 1 &&
                                    <>
                                        <div className={styles.check_list_progress_target} style={{ justifyContent: "start" }}>
                                            <Text as="div" variant="body" className={styles.check_list_progress_target_text} >{data.countTotal}</Text>
                                            <FlagIcon className={styles.check_list_progress_target_icon} />
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>

                    <DeleteIcon className={styles.deleteIcon} onClick={(e) => {
                        e.stopPropagation();
                        open();
                    }} />
                </div>
            </div>

            {Popup}
        </>
    );
}